import { LargeVisionActionTypes } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import { InteractionsTotal } from '../../types'

/**
 * Large Vision total interactions reducer
 */
const largeVisionInteractionsTotal = buildAsyncStatReducer({
    key: Metrics.LARGEVISION_INTERACTIONS_TOTAL,
    types: {
        request: LargeVisionActionTypes.DASHBOARD_LARGEVISION_INTERACTIONS_TOTALS.request,
        success: LargeVisionActionTypes.DASHBOARD_LARGEVISION_INTERACTIONS_TOTALS.success,
        failure: LargeVisionActionTypes.DASHBOARD_LARGEVISION_INTERACTIONS_TOTALS.failure,
    },
    transform: (state, { payload }): InteractionsTotal => {
        const item = payload[0] || {}
        const total: number = item.count
        return { total }
    },
})

export default largeVisionInteractionsTotal
